import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { UserStore } from '../../../store/user/user.store';

export const onboardingDemographicsMatchGuard: CanMatchFn = (route, segments) => {
  const userStore = inject(UserStore)

  return userStore.onboarding_status() >= 0 && !userStore.active() ? true : false
};
